import { AccountClass } from "@common/constants/domains/accounting/accounts";
import { z } from "zod";

export const importedAccountGroupSchema = z.object({
    id: z.string().uuid(),
    accountingMigrationId: z.string().uuid(),
    providerId: z.string(),
    name: z.string(),
    code: z.string().nullable(),
    classification: z.nativeEnum(AccountClass),
    cashOpeningBalance: z.number().nullable(),
    accrualOpeningBalance: z.number().nullable(),
    parentGroupId: z.string().uuid().nullable(),
    accountGroupId: z.string().uuid().nullable(),
    sortOrder: z.number(),
});

export type ImportedAccountGroup = z.infer<typeof importedAccountGroupSchema>;
